import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-search-footer',
  templateUrl: './search-footer.component.html',
  styles: []
})
export class SearchFooterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
